export enum NotificationType {
  ACCESS_REQUEST_RECEIVED = 'access_request_received',
  ACCESS_REQUEST_ACCEPTED = 'access_request_accepted',
  ACCESS_REQUEST_REJECTED = 'access_request_rejected',
  ACCESS_REQUEST_EXPIRING = 'access_request_expiring',
  ACCESS_REQUEST_EXPIRED = 'access_request_expired',
  ACCESS_REVOKED = 'access_revoked',
  CV_VIEWED = 'cv_viewed',
  ADDED_TO_PIPELINE = 'added_to_pipeline',
  STATUS_CHANGED = 'status_changed',
  INTERVIEW_SCHEDULED = 'interview_scheduled',
  INTERVIEW_REMINDER = 'interview_reminder',
  INTERVIEW_CANCELLED = 'interview_cancelled',
  RECRUITMENT_FINALIZED = 'recruitment_finalized',
  NEW_MESSAGE = 'new_message',
  APPLICATION_STAGE_CHANGED = 'application_stage_changed',
  APPLICATION_OUTCOME_HIRED = 'application_outcome_hired',
  APPLICATION_OUTCOME_REJECTED = 'application_outcome_rejected',
  APPLICATION_AWAITING_CANDIDATE = 'application_awaiting_candidate',
  APPLICATION_MEETING_SCHEDULED = 'application_meeting_scheduled',
  APPLICATION_MEETING_RESCHEDULED = 'application_meeting_rescheduled',
  APPLICATION_MEETING_CANCELLED = 'application_meeting_cancelled',
  APPLICATION_MESSAGE_RECEIVED = 'application_message_received',
}
